import { BaseModel } from "../../../service/models/base";
import { SpocModel, WarehouseModel } from "./warehouse_model";

export interface    WarehouseInventorySpocModel extends BaseModel {
    warehouse_id?: string;
    warehouse_name?: string;
    warehouse?: WarehouseModel;
    inventory_spocs?: SpocModel[];
    role?: string;//super=admin created manger, manager creates operator
    isReportingManager?: boolean;
    reporting_to_id?: string;
    reporting_to_name?: string;
    status?: string;
}

export const warehouseRoles = {
    manager: "manager",
    "warehouse operator": "warehouse operator"
}

export interface TeamManagementOfWarehosues {
    member: SpocModel;
    role?: string;
    warehouses: WarehouseModel[];
}